module.exports = __webpack_public_path__ + "img/image_frame.13e0c558.png";